import i18n from 'i18n'
import { Metadata } from '../adaptor/metadata'
import { FieldResolver } from './fieldResolver'
import resolveCleanTextRelatedFields from './cleanText/cleanTextUtil'

export const cleanTextRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = resolveCleanTextRelatedFields(metadata)
  if (metadata.isDeleted()) {
    delete result.reviewData
    result = { ...result, cleanText: i18n.t('postDeletedByAuthor') }
  }

  return result
}

export default cleanTextRelatedFieldsResolver
